module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN322_1227292792.c6387aee.png";